import { defineMessages } from 'react-intl';

export default defineMessages({
  reprocessAutomationRules: {
    description: 'Automation reprocess modal header',
    defaultMessage: 'Reprocess Automation Rules',
    id: 'MpCpeV',
  },
  areYouSure: {
    description: 'bold text to tell users they are doing a thing',
    defaultMessage: '<b>Are you sure you want to reprocess all open orders?</b>',
    id: 'DF26lP',
  },
  pleaseNote: {
    description: 'please note',
    defaultMessage: 'Please note the following:',
    id: 'YfETjt',
  },
  modifyOpen: {
    description: 'might modify open orders',
    defaultMessage: 'This may cause shipping information to be modified on open orders.',
    id: 'KflGo1',
  },
  reallyLongDescription: {
    description: 'description about what happens when open orders are reprocessed',
    defaultMessage:
      'When open orders are reprocessed, your automation, and other import rules are re-applied. However, we will not resend any confirmation e-mails that you may have set up with your automation rules; these will only be sent when orders are first imported. So, if you reprocess any order that has an e-mail sent via automation rule, these will not be resent. Additionally, we will neither apply Preset Group settings, nor will we add or subtract weight via automation rules to any existing orders.',
    id: 'g1bCyX',
  },
  runsInBackground: {
    description: 'we run this in the background',
    defaultMessage: 'This process will run in background and you will be notified when it has completed.',
    id: 'h/Jh1C',
  },
  takesAWhile: {
    description: 'this process takes a while',
    defaultMessage: 'This process can take several minutes to complete.',
    id: 'EpJyQF',
  },
  takeACoffeeBreak: {
    description: 'we recommend stopping shipping during this',
    defaultMessage: 'We recommend suspending all shipping while orders are reprocessed.',
    id: 'x6N/Iu',
  },
  clickToContinue: {
    description: 'click confirm to continue',
    defaultMessage: 'Click <b>Confirm</b> to continue.',
    id: 'GHyQ9x',
  },
  confirm: {
    description: 'confirm button text',
    defaultMessage: 'Confirm',
    id: '7cd5pp',
  },
  cancel: {
    description: 'Cancel button text',
    defaultMessage: 'Cancel',
    id: 'hHNj31',
  },
  reprocessBegunTitle: {
    description: 'reprocessing begun title',
    defaultMessage: 'Reprocess has begun!',
    id: 'opknsq',
  },
  reprocessBegunMessage: {
    description: 'reprocess begun message',
    defaultMessage: 'We are now reprocessing your open orders',
    id: 'iD1wVm',
  },
  errorReprocessingMessage: {
    description: 'error during reprocess',
    defaultMessage: 'We encountered an error trying to reprocess your automation rules',
    id: 'uyah5n',
  },
});
